import React from 'react'
import BreadCrumb from '../components/BreadCrumb';
import Meta from '../components/Meta';
import { Link } from 'react-router-dom';
import Container from '../components/Container';
import Custominput from '../components/Custominput';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from "react-redux";
import { loginUser } from '../features/user/userSlice';


const loginSchema = yup.object({
    email: yup.string().required('Please provide a valid email'),
    password: yup.string().required('Password is required'),
  });

const Login = () => {
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
          email: '',
          password: '',
        },
        validationSchema: loginSchema,
        onSubmit: (values) => {
        dispatch(loginUser(values))
        },
      });
  
  return (
    <>
         <Meta title={'Login'} />
        <BreadCrumb title='Login'/>
        <Container class1='login-wrapper py-5 home-wrapper-2'>
            <div className='row'>
                <div className='col-12'>
                    <div className='auth-card'>
                        <h3 className='text-center mb-3'>Login</h3>
                        <form action='' onSubmit={formik.handleSubmit} className='mt-3 d-flex flex-column gap-15'>
                            <Custominput 
                                type='email' 
                                name='email' 
                                placeholder='Email' 
                                onChange={formik.handleChange('email')}
                                onBlur={formik.handleBlur('email')}
                                value={formik.values.email}
                            />
                            <div className="error">
                                {formik.touched.email && formik.errors.email}
                            </div>
                            <Custominput 
                                className='mt-3' 
                                type='password' 
                                name='password' 
                                placeholder='Password' 
                                onChange={formik.handleChange('password')}
                                onBlur={formik.handleBlur('password')}
                                value={formik.values.password}
                            />
                            <div className="error">
                                {formik.touched.password && formik.errors.password}
                            </div>
                            <div>
                                <Link to='/forgot-password'>Forgot Password?</Link>
                                <div className='d-flex justify-content-center gap-15 align-items-center'>
                                    <button className='button border-0'>Login</button>
                                    <Link to='/signup' className='button signup'>Signup</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default Login